<template>
  <div
    v-if="availableBodyParts.includes(part.name)"
    :class="`image_${part.name}`"
  />
</template>

<script>
import config from '@/config';

export default {
  name: 'BodyPartImage',
  props: ['part'],
  computed: {
    availableBodyParts() {
      return config.availableBodyParts;
    },
  },
};
</script>

<style scoped lang="scss">
.image_body {
  mask: url('../assets/body.svg') no-repeat;
}

.image_back {
  mask: url('../assets/back.svg') no-repeat;
}

.image_shoulder {
  mask: url('../assets/shoulder.svg') no-repeat;
}

.image_legs {
  mask: url('../assets/leg.svg') no-repeat;
}

.image_hip {
  mask: url('../assets/hip.svg') no-repeat;
}

.image_neck {
  mask: url('../assets/neck.svg') no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/elements/BodyPartImage.vue